import { Modal as AntdModal, Row } from 'antd';
import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';
import PageTitle from '~atoms/PageTitle';

export const RemoveOptionModal = styled(AntdModal)({
  '.ant-modal-content': {
    width: '504rem',
    padding: '30rem',
  },

  '.ant-modal-close': {
    display: 'none',
  },
});

export const RemoveOptionModalTitle = styled(PageTitle)({
  fontWeight: 'normal',
});

export const RemoveOptionModalDescription = styled.p({
  marginBlock: '26rem 0',

  fontSize: '16rem',
});

export const RemoveOptionModaFooterContainer = styled(Row)({
  gap: '24rem',
  justifyContent: 'flex-end',
});

export const RemoveOptionModalButton = styled(CommonButton)(({ theme }) => ({
  height: '38rem',
  paddingInline: '20rem',
  marginBlockStart: '25rem',

  fontSize: theme.typography.size20,
}));

export const RemoveOptionModalCloseBtn = styled(RemoveOptionModalButton)(
  () => ({
    marginInlineStart: 'auto',
  })
);
